const query: string = `#graphql 
  query ($storeId: String!) {
    storeInformationById(storeId: $storeId) {
      subHeader
      searchSubHeader
      eventRentalEmailUrl
      foodOrderUrl
      fuelMenuSlug
      storeSpaceImageUrl
      studioSpaceImageUrl
      cafeSpaceImageUrl
    }
  }
`;

export default query;
